/**
 * uiTokens.js — constantes visuais JS que NÃO variam por modo (claro/escuro).
 *
 * Tints de status e a escala "slate" moraram aqui até 2026-09: viraram parte da ESCALA OPERACIONAL
 * por modo (`theme/operationalModes.js`). Nas Views, use as CSS vars: var(--tint-*), var(--slate-*).
 */

// Sombra sutil padrão de card (o "flat + shadow" do mockup). Usada pelo StandardCard legado.
export const cardShadow = '0 1px 2px rgba(16,24,40,0.04)';
